import Decimal from 'decimal.js';
import { PaymentDetailType } from 'anchor-scout-common/types';
import { InvoiceAccountingIntegration } from '../InvoiceAccountingIntegration';
import { InvoiceIntegrationModel } from '../InvoiceIntegrationModel';
import { PaymentModel } from '../PaymentModel';
const CLIENT_HIDDEN_PAYMENT_DETAILS = new Set([
    PaymentDetailType.PaymentStopped,
    PaymentDetailType.PaymentAwaitingInitiation,
    PaymentDetailType.PaymentScheduled,
    PaymentDetailType.PaymentInitiated,
    PaymentDetailType.PaymentCollected,
    PaymentDetailType.PaidOnDate,
    PaymentDetailType.PaidExternally,
    PaymentDetailType.Voided,
    PaymentDetailType.Disputed
]);
function filterPaymentDetailsForClient(details) {
    return details === null || details === void 0 ? void 0 : details.filter((d)=>!CLIENT_HIDDEN_PAYMENT_DETAILS.has(d.type));
}
export function fromDTO(isVendor, dto) {
    return {
        id: dto.id,
        attachments: dto.attachments || [],
        netTerms: dto.netTerms,
        createdOn: dto.createdOn,
        issuedOn: dto.issuedOn,
        dueDate: dto.dueDate,
        customerId: dto.customerId,
        isRetryable: dto.isRetryable,
        pdfExists: dto.pdfExists,
        totalAmount: dto.totalAmount,
        paymentMethodStatus: dto.paymentMethodStatus,
        formattedNumber: dto.formattedNumber,
        status: isVendor ? dto.vendorStatus : dto.customerStatus,
        displayStatus: dto.displayStatus,
        paymentDisplayStatus: isVendor ? dto.vendorPaymentDisplayStatus : dto.customerPaymentDisplayStatus,
        isTotalAmountZero: dto.isTotalAmountZero,
        integration: InvoiceIntegrationModel.fromScoutDTO(dto.integration),
        items: dto.items,
        relationship: dto.relationship,
        rawTotalAmount: new Decimal(dto.rawTotalAmount).div(100).toDP(2),
        rawDueDate: new Date(dto.rawDueDate),
        rawIssuedOn: new Date(dto.rawIssuedOn),
        rawCreatedOn: new Date(dto.createdOn),
        number: dto.number,
        xeroIntegration: InvoiceAccountingIntegration.fromDTO(dto.xeroIntegration),
        payment: dto.payment ? new PaymentModel(dto.payment) : null,
        displayStatusV2: dto.displayStatusV2,
        paymentDetails: isVendor ? dto.paymentDetails : filterPaymentDetailsForClient(dto.paymentDetails),
        isAdHoc: dto.isAdHoc,
        paymentMethodDisplay: dto.paymentMethodDisplay
    };
}
